import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
const OFFSET_X = 14;
const OFFSET_Y = 14;
const VIEWPORT_PAD = 8;
const ESTIMATED_WIDTH = 180;
const ESTIMATED_HEIGHT = 56;
export const MeasureDrawingHUD = ({ screenX, screenY, primaryText, secondaryText, }) => {
    let left = screenX + OFFSET_X;
    let top = screenY + OFFSET_Y;
    if (left + ESTIMATED_WIDTH > window.innerWidth - VIEWPORT_PAD) {
        left = screenX - ESTIMATED_WIDTH - OFFSET_X;
    }
    if (top + ESTIMATED_HEIGHT > window.innerHeight - VIEWPORT_PAD) {
        top = screenY - ESTIMATED_HEIGHT - OFFSET_Y;
    }
    return (_jsxs("div", { className: "fixed flex flex-col", style: {
            left,
            top,
            padding: '6px 10px',
            borderRadius: 6,
            backgroundColor: 'var(--charcoal)',
            boxShadow: '0 4px 14px rgba(0, 0, 0, 0.45)',
            zIndex: 1100,
            pointerEvents: 'none',
            userSelect: 'none',
            minWidth: 120,
        }, children: [_jsx("span", { className: "text-sm font-semibold", style: { color: 'var(--sand)' }, children: primaryText }), secondaryText && (_jsx("span", { className: "text-xs", style: { color: 'var(--dew)', opacity: 0.8, marginTop: 1 }, children: secondaryText }))] }));
};
